import { useAtomValue } from 'jotai/index';
import { cityAtom } from '@app/atoms/app/city.atom.ts';
import { useState } from 'react';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from '@heroui/react';
import { SearchLocation } from '@features/location/search-location';
import { Locations } from '@features/location/locations';

export const InitialLocationModal = () => {
  const selectedCity = useAtomValue(cityAtom);
  const [query, setQuery] = useState('');
  const modal = useDisclosure({
    isOpen: !selectedCity.id,
  });

  return (
    <Modal onOpenChange={modal.onOpenChange} size="3xl" isOpen={modal.isOpen}>
      <ModalContent>
        <ModalHeader className="">Выберите город</ModalHeader>
        <ModalBody className="pb-6">
          <SearchLocation onSearch={setQuery} />
          <Locations
            className="grid grid-cols-2 gap-x-6 gap-y-2"
            query={query}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
